window.jQuery = $;

makeAjaxCall = (type, endpoint, data, success, fail) => { // here the data and url are not hardcoded anymore
    let json_data = JSON.stringify(data);
    return $.ajax({
        type: type,
        url: endpoint,
        data: json_data,
        dataType: "json",
        contentType: "application/json;charset=utf-8",
        success: response => { success ? success(response) : "" },
        fail: response => { fail ? fail(response) : "" }
    });
}

formatDataToJson = (form) => {
    let data = form.serializeArray().reduce((obj, item) => {
        obj[item.name] = item.value;
        return obj;
    }, {});
    return data;
}

$(document).ready(function () {
    //Formulario de eventos
    $('#form-event').on("submit", function (e) {
        e.preventDefault();
        let successCallback = (response) => {
            if (response.hasOwnProperty('status')) {
                if (response.status === "ok") {
                    $(this).find("button").replaceWith("<h4>Formulario enviado :)</h4>")
                }
                else {
                    $(this).find("button").replaceWith("<h4>Ocurrió un error :(</h4>")
                }
            }
        }
        let failCallback = (response) => {
            $(this).find("button").replaceWith("<h4>Ocurrió un error :(</h4>")
        }
        makeAjaxCall("POST", "/api/inscripcion", formatDataToJson($(this)), successCallback, failCallback);
        return false;
    });
})
